"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendEventCommentClassStatus = void 0;
const HttpCodes_1 = __importDefault(require("configs/HttpCodes"));
const services_1 = require("modules/app/services");
const baseSchema_1 = require("modules/app/services/datahubEvents/baseSchema");
const utils_1 = require("modules/community/commentList/utils");
const MembershipService_1 = __importDefault(require("modules/membership/MembershipService"));
const tryComentClassStatus_1 = __importDefault(require("../../tryComentClassStatus"));
const sendEventCommentClassStatus = ({ isSuccess = true, status, statusCode = HttpCodes_1.default.OK, failureDescription = baseSchema_1.ResultType.FAILURE_DESCRIPTION, arrivedFromDropdownMenu = false, comment }) => {
    var _a, _b;
    const statusByEnum = (0, utils_1.getStatusEnum)(status);
    const schema = new tryComentClassStatus_1.default({
        isSuccess,
        status: statusByEnum,
        statusCode: isSuccess ? statusCode : HttpCodes_1.default.BAD_REQUEST,
        failureDescription,
        arrivedFromDropdownMenu,
        commentId: comment === null || comment === void 0 ? void 0 : comment.id,
        classroomId: String((_a = comment === null || comment === void 0 ? void 0 : comment.commentClass) === null || _a === void 0 ? void 0 : _a.id),
        userAreaId: (_b = comment === null || comment === void 0 ? void 0 : comment.user) === null || _b === void 0 ? void 0 : _b.userAreaId,
        productId: String(MembershipService_1.default === null || MembershipService_1.default === void 0 ? void 0 : MembershipService_1.default.productId)
    });
    services_1.DatahubEventsService.sendEvent({
        schema,
        clubVersion: baseSchema_1.ClubVersion.OLD_CLUB_ADMIN
    });
};
exports.sendEventCommentClassStatus = sendEventCommentClassStatus;
